import segmentInputsConfig from '../../scripts/segment-inputs-config/segment-config';

import template from './dynamic-segment-inputs.jade';

export default () => {
  return {
    scope: {},
    bindToController: {
      category: '=',
      categoryInfo: '=',
      segment: '@',
      ad: '=',
      form: '=',
      defaultConfig: '=',
    },
    controller(
      $scope,
      config,
      isSimpleFormEnabled,
      segmentFieldsLimitService,
      coworkingService,
      deviceService,
      businessService,
    ) {
      'ngInject';
      this.trackByFn = (row, index) => {
        return row.name + index;
      };

      $scope.$watchGroup([() => this.category, isSimpleFormEnabled], () => {
        this.accordionExpanded = false;
        this.hasAccordion = segmentFieldsLimitService.hasLimit(this.segment);
        this.accordionLimit = segmentFieldsLimitService.getLimit(this.segment);

        const { coworkingOfferType, isByCommercialOwner } = this.ad;

        this.config = this.category
          ? segmentInputsConfig(this.category, this.segment, {
              coworkingOfferType,
              isByCommercialOwner,
              isCommercialBusinessAvailable: businessService.isCommercialBusinessAvailable(),
            })
          : this.defaultConfig || null;

        if (!this.config) {
          return;
        }

        this.config = this.config.map(item => {
          if (typeof item === 'object') {
            return item;
          }

          return {
            name: item,
          };
        });

        this.config = this.config.map(item => {
          if (isSimpleFormEnabled()) {
            return {
              ...item,
              order: item.simpleForm && item.simpleForm.order,
            };
          }

          return item;
        });

        this.config = this.config.filter(item => {
          let isEnabled = true;

          // Если элемент не явлется объектом, выходим
          if (typeof item !== 'object') {
            return isEnabled;
          }

          if (item.hideOnMobile) {
            isEnabled = !deviceService.isMobile;
          }

          if (typeof item.hideInSimpleForm === 'boolean') {
            isEnabled = !isSimpleFormEnabled() || !item.hideInSimpleForm;
          }

          if (item.onlyShowInSimpleForm) {
            isEnabled = isSimpleFormEnabled();
          }

          return isEnabled;
        });
      });
    },
    controllerAs: 'dynamicSegmentInputsCtrl',
    template,
  };
};
